import { debtVerificationData } from './data';
import { DebtVerification } from './DebtVerification';

export const DebtVerificationCard = () => {
  const data = debtVerificationData?.data;
  return (
    <li className="w-full md:w-[789px] grid gap-4">
      <DebtVerification
        key={data?.id}
        type={data?.type}
        icon={data?.icon}
        title={data?.title}
        value={data?.value}
        errorMessage={data?.errorMessage}
      />
    </li>
  );
};
